<template>
  <div class="where-step min-h-full">


    <div class="flex items-center gap-2 mb-4">
      <h2 class="text-lg font-medium text-gray-900">WHERE - Localisation</h2>
      <BookCheckIcon v-show="isStepValid" class="w-5 h-5 text-green-500" />
    </div>

    <div class="space-y-6" :class="{ 'opacity-90': readOnlyConfig?.isReadOnly }">
      <LocationSelector :user-id="userId" :initial-location-id="modelValue.location_uuid"
        :read-only-config="readOnlyConfig" @location-selected="handleLocationSelected" />
    </div>
  </div>
</template>

<script lang="ts">
import type { ReadOnlyConfig } from '@/types/readOnly';
import { BookCheckIcon } from 'lucide-vue-next';
import { computed, defineComponent, watch } from 'vue';
import LocationSelector from '../selectors/LocationSelector.vue';

export default defineComponent({
  name: 'WhereStep',
  components: {
    LocationSelector,
    BookCheckIcon
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    userId: {
      type: String,
      required: true
    },
    readOnlyConfig: {
      type: Object as () => ReadOnlyConfig,
      required: false,
      default: () => ({ isReadOnly: false, allowNavigation: true, showEditHints: true })
    }
  },
  emits: ['update:model-value', 'can-proceed', 'isValid'],
  setup(props, { emit }) {
    // Computed property pour vérifier si l'étape est valide
    const isStepValid = computed(() => {
      return !!props.modelValue.location_uuid;
    });

    // Watch pour émettre l'état de validité quand il change
    watch(isStepValid, (newValue) => {
      emit('isValid', newValue);
    }, { immediate: true });

    // Gérer la sélection d'une localisation (protégé en mode readonly)
    const handleLocationSelected = (location: any): void => {
      if (props.readOnlyConfig?.isReadOnly) return;

      emit('update:model-value', {
        ...props.modelValue,
        location_uuid: location.uuid,
        location: location
      });
    };

    return {
      handleLocationSelected,
      isStepValid
    };
  }
});
</script>